import * as React from 'react';

import {
  IFileSearch,
  IMemberSearch,
  IPostSearch,
  ViewableAttributesField,
} from '@/client/legacy-shared-modules/search/search-types';
import { CustomHighlight } from '@/components/CustomHighlight';

export interface FormattedUserNameProps {
  hit: IPostSearch | IMemberSearch | IFileSearch;
  viewableAttributesField: ViewableAttributesField;
  fallbackDisplayName?: string;
}

export const FormattedUserName: React.FC<FormattedUserNameProps> = ({
  hit,
  viewableAttributesField,
  fallbackDisplayName,
}) => {
  const authorAttributes = hit[viewableAttributesField];

  // Helper function to format nameTitle
  // const formatNameTitle = (nameTitle: string): string => {
  //   // Handle both comma-separated and space-separated titles
  //   const parts = nameTitle
  //     .split(/[,\s]+/) // Split by both commas and spaces
  //     .map((title) => title.trim())
  //     .filter(Boolean); // Remove empty parts

  //   return parts.join(', ');
  // };

  // Component to render highlighted name
  const renderHighlightedName = () => {
    // If we have preferredName, highlight it directly
    if (authorAttributes?.preferredName) {
      return (
        <CustomHighlight
          attribute={`${viewableAttributesField}.preferredName`}
          hit={hit}
        />
      );
    }

    // For concatenated names, we need to highlight individual parts
    const nameParts = [];

    if (authorAttributes?.prefix && authorAttributes.prefix !== '') {
      nameParts.push(
        <CustomHighlight
          key="prefix"
          attribute={`${viewableAttributesField}.prefix`}
          hit={hit}
        />
      );
      if (!authorAttributes.prefix.endsWith('.')) {
        nameParts.push('.');
      }
    }

    if (authorAttributes?.firstName) {
      nameParts.push(
        <CustomHighlight
          key="firstName"
          attribute={`${viewableAttributesField}.firstName`}
          hit={hit}
        />
      );
    }

    if (authorAttributes?.lastName) {
      nameParts.push(' ');
      nameParts.push(
        <CustomHighlight
          key="lastName"
          attribute={`${viewableAttributesField}.lastName`}
          hit={hit}
        />
      );
      nameParts.push(' ');
    }

    if (authorAttributes?.suffix && authorAttributes.suffix !== '') {
      nameParts.push(
        <CustomHighlight
          key="suffix"
          attribute={`${viewableAttributesField}.suffix`}
          hit={hit}
        />
      );
      if (!authorAttributes.suffix.endsWith('.')) {
        nameParts.push('.');
      }
    }

    if (authorAttributes?.nameTitle && authorAttributes.nameTitle !== '') {
      nameParts.push(', ');
      nameParts.push(
        <CustomHighlight
          key="nameTitle"
          attribute={`${viewableAttributesField}.nameTitle`}
          hit={hit}
        />
      );
    }

    // If no individual parts are available, fall back to displayName
    if (nameParts.length === 0) {
      return <CustomHighlight attribute="displayName" hit={hit} />;
    }
    return <>{nameParts}</>;
  };

  return <>{renderHighlightedName()}</>;
};
